'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _reactRouter = require('react-router');

var _reactRedux = require('react-redux');

var _voucher = require('redux/modules/voucher');

var voucherActions = _interopRequireWildcard(_voucher);

var _booking = require('redux/modules/booking');

var bookingActions = _interopRequireWildcard(_booking);

var _setup = require('redux/modules/setup');

var setupActions = _interopRequireWildcard(_setup);

var _components = require('components');

var _support = require('helpers/support');

var _lib = require('helpers/lib');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PromotionAtSpa = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    promotions: state.voucher.promotions,
    promotionLoaded: state.voucher.promotionLoaded,
    REWARD_LIST_AT_HOME: state.voucher.REWARD_LIST_AT_HOME,
    MY_REWARD_LIST: state.voucher.MY_REWARD_LIST,
    EXCHANGE_REWARD: state.voucher.EXCHANGE_REWARD
  };
}, {
  getAllReward: voucherActions.getAllReward,
  getMyReward: voucherActions.getMyReward,
  changeTab: voucherActions.changeTab,
  beforeExchangeReward: voucherActions.beforeExchangeReward,
  exchangeReward: voucherActions.exchangeReward,
  resetBooking: bookingActions.resetBooking,
  setDefaultBooking: bookingActions.setDefaultBooking,
  changeShopBeforeBooking: bookingActions.changeShopBeforeBooking,
  showDownloadAppPopup: setupActions.showDownloadAppPopup
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PromotionAtSpa, _Component);

  function PromotionAtSpa(props) {
    (0, _classCallCheck3.default)(this, PromotionAtSpa);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PromotionAtSpa.__proto__ || (0, _getPrototypeOf2.default)(PromotionAtSpa)).call(this, props));

    _this.userNo = -1;

    _this.renderAllReward = _this.renderAllReward.bind(_this);
    _this.getButtonByShop = _this.getButtonByShop.bind(_this);
    _this.state = {
      showErr: false,
      contentErr: {
        title: { text: 'Lỗi', type: 'error' },
        message: []
      },
      showFlow: false,
      contentFlow: {
        title: { text: 'Thông Báo', type: 'success' },
        message: []
      }
    };
    return _this;
  }

  (0, _createClass3.default)(PromotionAtSpa, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var user = this.props.user;

      this.userNo = _support.Helper.rankNo(user ? user.rank : null);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.REWARD_LIST_AT_HOME.loading !== nextProps.REWARD_LIST_AT_HOME.loading && !nextProps.REWARD_LIST_AT_HOME.loading && this.props.getOffset) {
        this.props.getOffset();
      }
    }
  }, {
    key: 'getButtonExchangeReward',
    value: function getButtonExchangeReward(_ref) {
      var _this2 = this;

      var type = _ref.type,
          reward = _ref.reward;

      console.warn('@getButtonExchangeReward: type - ', type, '|| reward - ', reward);
      switch (type) {
        case 'EXCHANGE_REWARD_SUCCESS':
          return [this.getButtonByShop(reward.couponCode), {
            text: 'Ưu Đãi Của Tôi',
            onClick: function onClick() {
              _this2.hideFlow();
              _this2.toMyReward();
            }
          }, {
            text: 'Thoát',
            type: 'default',
            onClick: function onClick() {
              return _this2.hideFlow();
            }
          }];
        case 'REWARD_EXISTED':
          return [this.getButtonByShop(reward.couponCode), {
            text: 'Chi Tiết Ưu Đãi',
            onClick: function onClick() {
              return _this2.toBookingReward(reward.couponCode.code);
            }
          }, {
            text: 'Thoát',
            type: 'default',
            onClick: function onClick() {
              return _this2.hideFlow();
            }
          }];
        case 'EXCHANGE_REWARD_FAIL':
          return [{
            text: 'Thoát',
            type: 'default',
            onClick: function onClick() {
              return _this2.hideFlow();
            }
          }];
        case 'CONFIRM_EXCHANGE_REWARD':
          return [{
            text: 'Chắc chắn',
            onClick: function onClick() {
              _this2.hideFlow();
              _this2.exchange(reward);
              _reactGa2.default.event({
                category: 'Promotion',
                action: 'Clicked Exchange button',
                label: '' + reward.packId
              });
            }
          }, {
            text: 'Thoát',
            type: 'default',
            onClick: function onClick() {
              return _this2.hideFlow();
            }
          }];
        case 'REQUIRE_LOGIN':
          return [{
            text: 'Đăng nhập',
            onClick: function onClick() {
              _this2.hideFlow();
              _this2.toLogin();
            }
          }, {
            text: 'Thoát',
            type: 'default',
            onClick: function onClick() {
              return _this2.hideFlow();
            }
          }];
        default:
          break;
      }
      return [];
    }
  }, {
    key: 'exchange',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(item) {
        var exchangeReward, res, content, couponCode;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                exchangeReward = this.props.exchangeReward;
                _context.next = 3;
                return exchangeReward(item);

              case 3:
                res = _context.sent;

                console.warn('res', res);
                content = {};

                if (res.success) {
                  couponCode = res.data.couponCode;

                  if (res.type === 'TO_BOOKING') {
                    this.toBooking(couponCode);
                  } else {
                    content = res.content;
                    content.button = this.getButtonExchangeReward({
                      type: res.type,
                      reward: res.data
                    });
                    this.setState({ contentFlow: content, showFlow: true });
                  }
                } else {
                  content = res.content;
                  content.button = this.getButtonExchangeReward({
                    type: res.type,
                    reward: res.data
                  });
                  this.setState({ contentErr: content, showErr: true });
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function exchange(_x) {
        return _ref2.apply(this, arguments);
      }

      return exchange;
    }()
  }, {
    key: 'onExchange',
    value: function onExchange(e, item) {
      e.stopPropagation();
      this.props.showDownloadAppPopup();
      // const res = this.props.beforeExchangeReward(item);
      // if (res.type === 'REQUIRE_EXCHANGE_SHOP') {
      //   this.props.history.push(`/uu-dai/${item.handle}?branch=true`);
      // } else {
      //   const contentFlow = { ...res.content };
      //   contentFlow.button = this.getButtonExchangeReward({
      //     type: res.type,
      //     reward: res.data,
      //   });
      //   this.setState({ contentFlow, showFlow: true });
      // }
    }
  }, {
    key: 'getButtonByShop',
    value: function getButtonByShop(coupon) {
      var _this3 = this;

      if (coupon && coupon.packageService) {
        var shop = coupon.packageService.shop;

        var btn = {};

        if (shop && shop.isBooking) {
          btn = {
            text: 'Đặt Lịch',
            onClick: function onClick() {
              _this3.hideFlow();
              _this3.toBooking(coupon);
            }
          };
        } else if (shop && !shop.isBooking) {
          btn = {
            text: 'Gọi Đặt Lịch',
            onClick: function onClick() {
              _this3.hideFlow();
              _this3.toCallShop(shop);
            }
          };
        }
        return btn;
      }
      return {};
    }
  }, {
    key: 'toBooking',
    value: function toBooking(coupon) {
      this.props.showDownloadAppPopup();
      // const {
      //   packageService: { shop, service },
      //   code,
      // } = coupon;
      // const {
      //   resetBooking,
      //   setDefaultBooking,
      //   history,
      //   changeShopBeforeBooking,
      //   user,
      // } = this.props;
      // resetBooking();
      // changeShopBeforeBooking(shop, user);
      // const bookingServices = [
      //   { service: service._id, number: 1, name: service.name },
      // ];
      // const submit = { bookingServices, code, shop, coupon };
      // setDefaultBooking(submit);
      // history.push(`/dat-lich`);
    }
  }, {
    key: 'toCallShop',
    value: function toCallShop(shop) {
      if (shop) {
        window.open('tel:' + (0, _lib.getPhone)(shop.phone));
      }
    }
  }, {
    key: 'toAllReward',
    value: function toAllReward(seeMore) {
      this.props.changeTab('allReward');
      if (seeMore === true) {
        _reactGa2.default.event({
          category: 'Home Section',
          action: 'Clicked See More',
          label: 'Promotion'
        });
      } else {
        _reactGa2.default.event({
          category: 'Home Section',
          action: 'Clicked Title',
          label: 'Promotion'
        });
      }
    }
  }, {
    key: 'toMyReward',
    value: function toMyReward() {
      this.props.changeTab('myReward');
      this.props.history.push('/uu-dai');
    }
    // const reward = myRewards.filter(v => v.packageService._id === packId);

  }, {
    key: 'toRewardDetail',
    value: function toRewardDetail(item, prefixCode, id) {
      this.props.history.push('/uu-dai/' + item.handle);
      _reactGa2.default.event({
        category: 'Promotion',
        action: 'Clicked Voucher Card',
        label: '' + (prefixCode ? prefixCode : id)
      });
    }
  }, {
    key: 'toBookingReward',
    value: function toBookingReward(code) {
      this.props.history.push('/uu-dai-cua-toi/' + code);
    }
  }, {
    key: 'toLogin',
    value: function toLogin() {
      this.props.history.push('/dang-nhap');
    }
  }, {
    key: 'showError',
    value: function showError() {
      this.setState({ showErr: true });
    }
  }, {
    key: 'hideError',
    value: function hideError() {
      this.setState({ showErr: false });
    }
  }, {
    key: 'showFlow',
    value: function showFlow() {
      this.setState({ showFlow: true });
    }
  }, {
    key: 'hideFlow',
    value: function hideFlow() {
      this.setState({ showFlow: false });
    }
  }, {
    key: 'renderAllReward',
    value: function renderAllReward(item, i) {
      var _this4 = this;

      var styles = require('./MobileBox.scss');
      var userNo = this.userNo;
      var prefixCode = item.prefixCode,
          id = item.id;

      var _item = _support.Helper.parsePackageServiceToCard(item);
      if (_item.forRank && _item.forRank.type && userNo !== -1) {
        var campaignNo = _support.Helper.rankNo(_item.forRank.type);
        _item.allowExchange = userNo >= campaignNo;
      }
      return _react2.default.createElement(_components.RewardItem, {
        style: styles.rewardItem,
        imgStyle: styles.imgStyle,
        key: 'rewardItem_' + i,
        item: _item,
        onPress: function onPress() {
          return _this4.toRewardDetail(_item, prefixCode, id);
        },
        onExchange: function onExchange(e) {
          return _this4.onExchange(e, _item);
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var styles = require('./MobileBox.scss');
      var _props = this.props,
          slogan = _props.slogan,
          title = _props.title,
          promotionHandle = _props.promotionHandle,
          staticOn = _props.staticOn,
          tabOn = _props.tabOn;

      var data = this.props.REWARD_LIST_AT_HOME.data;
      if (promotionHandle && data) {
        data = data.filter(function (item) {
          return item && item.handle !== promotionHandle;
        });
      }
      var _state = this.state,
          showErr = _state.showErr,
          contentErr = _state.contentErr,
          showFlow = _state.showFlow,
          contentFlow = _state.contentFlow;

      if (data && data.length > 0) {
        return _react2.default.createElement(
          'div',
          {
            className: styles.promotion + ' homePromotion ' + (staticOn && styles.staticBg)
          },
          tabOn ? _react2.default.createElement(
            'div',
            { className: styles.tabHeaderBox },
            _react2.default.createElement(
              'div',
              { className: styles.header },
              _react2.default.createElement(
                'h1',
                { className: styles.slogan },
                'Ti\u1EC7n h\u01A1n, th\u01B0 th\xE1i h\u01A1n'
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                {
                  to: {
                    pathname: '/uu-dai-tai-nha',
                    state: { dynamicData: data, homeOff: true }
                  },
                  className: styles.seeMore,
                  onClick: function onClick() {
                    return _this5.toAllReward(true);
                  }
                },
                'Xem th\xEAm'
              )
            )
          ) : _react2.default.createElement(
            'div',
            {
              className: styles.headerBox,
              style: { backgroundColor: 'rgba(28, 207, 206, 0.1)' }
            },
            _react2.default.createElement(
              'div',
              { className: styles.header },
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/uu-dai', onClick: function onClick() {
                    return _this5.toAllReward();
                  } },
                _react2.default.createElement(
                  'div',
                  { className: styles.left },
                  _react2.default.createElement(
                    'h1',
                    { className: styles.title },
                    title ? title : 'Ưu đãi tại nhà'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.right },
                _react2.default.createElement(
                  _reactRouter.Link,
                  {
                    to: '/uu-dai-tai-nha',
                    className: styles.seeMore,
                    onClick: function onClick() {
                      return _this5.toAllReward(true);
                    }
                  },
                  'Xem th\xEAm'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.slogan, style: { marginBottom: 5 } },
              slogan
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.bodyBox },
            data && data.length > 1 ? data.map(function (item, i) {
              return _this5.renderAllReward(item, i);
            }) : data && data.length === 1 && _react2.default.createElement(
              'div',
              { className: styles.onlyOne },
              data.map(function (item, i) {
                return _this5.renderAllReward(item, i);
              })
            )
          ),
          _react2.default.createElement(_components.ModalCustom, {
            key: 'modal_flow_promotion',
            show: showFlow,
            onHide: this.hideFlow.bind(this),
            title: contentFlow.title,
            message: contentFlow.message,
            button: contentFlow.button,
            closeButton: true
          }),
          _react2.default.createElement(_components.ModalCustom, {
            key: 'modal_error_promotions',
            show: showErr,
            onHide: this.hideError.bind(this),
            title: contentErr.title,
            message: contentErr.message,
            button: contentErr.button,
            closeButton: true
          })
        );
      }
      return _react2.default.createElement('div', null);
    }
  }]);
  return PromotionAtSpa;
}(_react.Component), _class2.propTypes = {
  // @data
  slogan: _react.PropTypes.string,
  promotionHandle: _react.PropTypes.string,
  user: _react.PropTypes.object,
  history: _react.PropTypes.object,
  location: _react.PropTypes.object,
  title: _react.PropTypes.string,
  MY_REWARD_LIST: _react.PropTypes.object,
  REWARD_LIST_AT_HOME: _react.PropTypes.object,
  EXCHANGE_REWARD: _react.PropTypes.object,
  staticOn: _react.PropTypes.bool,
  tabOn: _react.PropTypes.bool,
  // @action
  getAllReward: _react.PropTypes.func,
  getMyReward: _react.PropTypes.func,
  beforeExchangeReward: _react.PropTypes.func,
  exchangeReward: _react.PropTypes.func,
  setCouponCode: _react.PropTypes.func,
  getOffset: _react.PropTypes.func,
  changeTab: _react.PropTypes.func,
  setDefaultBooking: _react.PropTypes.func,
  resetBooking: _react.PropTypes.func,
  changeShopBeforeBooking: _react.PropTypes.func,
  showDownloadAppPopup: _react.PropTypes.func
}, _temp)) || _class);
exports.default = PromotionAtSpa;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Home/PromotionAtHome.js
// module id = 1606
// module chunks = 0